import { useState, useEffect } from "react";
import api from "../../axiosconfig";

const defaultScores = {
    physical: 0,
    emotional: 0,
    acceptance: 0,
    relationships: 0,
    lovingKindness: 0,
    intelligence: 0,
};

export default function usePearliScores(viewMode, url) {
    const [scores, setScores] = useState(defaultScores);
    const [previousScores, setPreviousScores] = useState(defaultScores);

    const [filteredCount, setFilteredCount] = useState(0);
    const [totalCount, setTotalCount] = useState(0);

    const [loading, setLoading] = useState(false);

    // Removes all filters from URL for total participant count
    const stripFilters = (urlString) => {
        const base = new URL(urlString, window.location.origin);
        const params = base.searchParams;

        // remove filter keys
        const filterKeys = [
            "age", "gender", "location", "description",
            "job_title", "company", "interest",
        ];

        filterKeys.forEach((k) => params.delete(k));

        return base.pathname + "?" + params.toString();
    };

    useEffect(() => {
        if (viewMode !== "current") return;

        const fetchScores = async () => {
            try {
                setLoading(true);

                // Filtered request
                const res = await api.get(url);
                const d = res?.data?.data?.scores;
                const count = res?.data?.data?.count ?? 0;

                const newScores = {
                    physical: d?.AvgP ?? null,
                    emotional: d?.AvgE ?? null,
                    acceptance: d?.AvgA ?? null,
                    relationships: d?.AvgR ?? null,
                    lovingKindness: d?.AvgL ?? null,
                    intelligence: d?.AvgI ?? null,
                };

                setPreviousScores(scores);
                setScores(newScores);
                setFilteredCount(count);

                // Unfiltered request -> total participants
                const unfilteredUrl = stripFilters(url);
                const totalRes = await api.get(unfilteredUrl);
                const total = totalRes?.data?.data?.count ?? 0;

                setTotalCount(total);
            } catch (e) {
                console.error("usePearliScores error:", e);
            } finally {
                setLoading(false);
            }
        };

        fetchScores();
    }, [viewMode, url]);

    // Determine if we have valid data
    const hasData = 
        filteredCount > 0 && 
        Object.values(scores).every(v => v !== null && typeof v === 'number');

    return {
        scores,
        previousScores,
        filteredCount,
        totalCount,
        loading,
        hasData,
    };
}
